import { createSelector } from 'reselect'
import { getLocaleByLang } from 'locale'

export const getLang = (state, props) => {
  return state.kanbo.locale.lang
}

export const getMessages = (state, props) => {
  return state.kanbo.locale.messages
}

export default createSelector(
  [
    getLang,
    getMessages
  ],
  (
    lang,
    messages
  ) => ({
    lang,
    locale: getLocaleByLang(lang),
    messages
  })
)
